import { CognitoUserPool, CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_5f6hmtV1B", // Replace with actual User Pool ID
  ClientId: "6l5th1aqsca3hb2ntt4dhfk690",  // Replace with actual App Client ID
};

const UserPool = new CognitoUserPool(poolData);
export interface AuthResponse {
  idToken: string;
  accessToken: string;
  refreshToken: string;
}

export const authenticateUser = (userName: string, password: string): Promise<AuthResponse> => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: userName,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: userName,
      Password: password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        resolve({
          idToken: session.getIdToken().getJwtToken(),
          accessToken: session.getAccessToken().getJwtToken(),
          refreshToken: session.getRefreshToken().getToken(),
        });
      },
      onFailure: (err) => {
        reject(err);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        reject({ newPasswordRequired: true, user, userAttributes });
      },
    });
  });
};


export const setAuthToken = (token: string) => {
  localStorage.setItem("accessToken", token);
};

export const getAuthToken = () => {
  return localStorage.getItem("accessToken");
};

export const attachAuthHeader = (headers: HeadersInit = {}) => {
  const token = getAuthToken();
  return token ? { ...headers, token } : headers;
};

export default UserPool;
